// extracted by mini-css-extract-plugin
module.exports = {"copy-to-clipboard":"Global_copy-to-clipboard__7k1o8","navbar":"Global_navbar__o2xXl"};